import React, { useEffect, useState } from 'react';
import { getFreeDemoList } from "../services/tenant-identity-service";
import { Link } from 'react-router-dom';
import '../styles/loader.scss';
import { getDecodedTokenDetails } from '../services/cognito-token-service';
import Loader from '../images/transparent-loader.png';
import DataGrid, {
    Column, Pager,
    Paging,
    SearchPanel, Export,
    FilterRow
} from 'devextreme-react/data-grid';


let SearchParam = require('wherecomposer/dist/SearchParam').SearchParam;
let SearchOperationBuilder = require('wherecomposer/dist/SearchParam').SearchOperationBuilder;
let ConditionCreator = require('wherecomposer/dist/ConditionCreator').ConditionCreator;

function FreeDemoInfo(props) {
    const [freeDemoList, setFreeDemoList] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const pageSizes = [10, 25, 50, 100];

    useEffect(() => {
        getCalendlyFreeDemoList();
        return () => {
        };

    }, []);

    const getCalendlyFreeDemoList = async () => {
        try {
            setLoading(true);
            let decodedToken = await getDecodedTokenDetails();
            let empl_id = decodedToken.empl_id;
            let response = await getFreeDemoList();

            response.forEach((obj) => {
                if (obj.hasOwnProperty('Employee')) {
                    if (Object.keys(obj.Employee).length == 0) {
                        if (obj.empl_id == empl_id) {
                            let employeeObj = {
                                'userName': decodedToken.userName
                            }

                            Object.assign(obj, { 'Employee': employeeObj });
                        } else if (obj.empl_id == 0) {
                            let employeeObj = {
                                'userName': 'Online'
                            }

                            Object.assign(obj, { 'Employee': employeeObj });
                        }
                    }
                } else {
                    if (obj.empl_id == empl_id) {
                        let employeeObj = {
                            'userName': decodedToken.userName
                        }

                        Object.assign(obj, { 'Employee': employeeObj });
                    } else if (obj.empl_id == 0) {
                        let employeeObj = {
                            'userName': 'Online'
                        }

                        Object.assign(obj, { 'Employee': employeeObj });
                    }
                }
            });

            setFreeDemoList(response);
            setLoading(false);
        } catch (error) {
            console.log('getCalendlyFreeDemoList error', error);
            setLoading(false);
        }

    }

    const calculateSerialNo = (cellInfo) => {
        return cellInfo.rowIndex + 1;
    }

    return (
        <div className="App">
            <div className="logout_btn">
                <Link to='/ServiceList'>
                    <div className="login_submit_button text-center">Back</div>{' '}
                </Link>
            </div>
            <DataGrid
                dataSource={freeDemoList}
                keyExpr="calendly_info_guid"
                allowColumnResizing={true}
                focusedRowEnabled={true}
                wordWrapEnabled={true}
                focusedRowKey={1}
                allowColumnReordering={true}
                showBorders={true}>
                <Paging enabled={false} />
                <Export enabled={true} />
                <FilterRow visible={true} />
                <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
                <Paging defaultPageSize={50} />
                <SearchPanel visible={true} highlightCaseSensitive={true} />
                <Column
                    caption="SI NO"
                    cellRender={calculateSerialNo}
                />
                <Column
                    dataField="fullName"
                    caption="Name"
                />
                <Column
                    dataField="companyName"
                    caption="Company Name"
                />
                <Column
                    dataField="email"
                    caption="Email"
                />
                <Column
                    dataField="phone_number"
                    caption="Mobile No"
                />
                <Column
                    dataField="location"
                    caption="Location"
                />
                <Column
                    dataField="suggestion"
                    caption="Description"
                />
                <Column
                    dataField="text_message_number"
                    caption="Text Message No"
                />
                <Column
                    dataField="createdDate"
                    caption="Created Date"
                    dataType="datetime"
                />
                <Column
                    dataField="Employee.userName"
                    caption="Employee"
                />
                <Column
                    dataField="empl_id"
                    caption="Employee Id"
                />
                <Column
                    dataField="campaign_id"
                    caption="Campaign Id"
                />
            </DataGrid>
            {
                isLoading ? (
                    <img src={Loader} alt="" className="loader" />
                ) : null
            }
        </div>
    )

}

export default FreeDemoInfo
